import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Index',
        component: Index
    },
    {
        path: '/School',
        name: 'School',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/School.vue')
    },
    {
        path: '/System',
        name: 'System',
        component: () =>
            import ('../views/System.vue')
    },
    {
        path: '/Smallprogram',
        name: 'Smallprogram',
        component: () =>
            import ('../views/Smallprogram.vue')
    },
    {
        path: '/Wemedia',
        name: 'Wemedia',
        component: () =>
            import ('../views/Wemedia.vue')
    },
    {
        path: '/Meltmedia',
        name: 'Meltmedia',
        component: () =>
            import ('../views/Meltmedia.vue')
    },
    {
        path: '/Carhome',
        name: 'Carhome',
        component: () =>
            import ('../views/Carhome.vue')
    },
    {
        path: '/Video',
        name: 'Video',
        component: () =>
            import ('../views/Video.vue')
    },
    {
        path: '/Newsdetail',
        name: 'Newsdetail',
        component: () =>
            import ('../views/Newsdetail.vue')
    },
    {
        path: '/News',
        name: 'News',
        component: () =>
            import ('../views/News.vue')
    },
    {
        path: '/Reschool',
        name: 'Reschool',
        component: () =>
            import ('../views/Reschool.vue')
    },
    {
        path: '/Guide',
        name: 'Guide',
        component: () =>
            import ('../views/Guide.vue')
    },
    {
        path: '/Aboutwe',
        name: 'Aboutwe',
        component: () =>
            import ('../views/Aboutwe.vue')
    },
    {
        path: '/Cooperation',
        name: 'Cooperation',
        component: () =>
            import ('../views/Cooperation.vue')
    },
    {
        path: '/SubjectDetail',
        name: 'SubjectDetail',
        component: () =>
            import ('../views/SubjectDetail.vue')
    },
    {
        path: '/SubjectDetail2',
        name: 'SubjectDetail2',
        component: () =>
            import ('../views/SubjectDetail2.vue')
    },
    {
        path: '/SubjectDetail3',
        name: 'SubjectDetail3',
        component: () =>
            import ('../views/SubjectDetail3.vue')
    },
    {
        path: '/SubjectDetail4',
        name: 'SubjectDetail4',
        component: () =>
            import ('../views/SubjectDetail4.vue')
    },
    {
        path: '/SubjectDetail5',
        name: 'SubjectDetail5',
        component: () =>
            import ('../views/SubjectDetail5.vue')
    },
    {
        path: '/SubjectDetail6',
        name: 'SubjectDetail6',
        component: () =>
            import ('../views/SubjectDetail6.vue')
    },
    {
        path: '/Moni1',
        name: 'Moni1',
        component: () =>
            import ('../views/Moni1.vue')
    },
    {
        path: '/Moni4',
        name: 'Moni4',
        component: () =>
            import ('../views/Moni4.vue')
    },
    {
        path: '/Achievements',
        name: 'Achievements',
        component: () =>
            import ('../views/Achievements.vue')
    },
    {
        path: '/Recruitment',
        name: 'Recruitment',
        component: () =>
            import ('../views/Recruitment.vue')
    },
    {
        path: '/Contact',
        name: 'Contact',
        component: () =>
            import ('../views/Contact.vue')
    },
    {
        path: '/AboutNews',
        name: 'AboutNews',
        component: () =>
            import ('../views/AboutNews.vue')
    },
    {
        path: '/AboutNewsdetail',
        name: 'AboutNewsdetail',
        component: () =>
            import ('../views/AboutNewsdetail.vue')
    },
    {
        path: '/Skill',
        name: 'Skill',
        component: () =>
            import ('../views/Skill.vue')
    },
    {
        path: '/Bannerdetail',
        name: 'Bannerdetail',
        component: () =>
            import ('../views/Bannerdetail.vue')
    },
    {
        path: '/DriveSystem',
        name: 'DriveSystem',
        component: () =>
            import ('../views/DriveSystem.vue')
    },
    {
        path: '/SmallMark',
        name: 'SmallMark',
        component: () =>
            import ('../views/SmallMark.vue')
    },
    {
        path: '/addvalue',
        name: 'addvalue',
        component: () =>
            import ('../views/addvalue.vue')
    },
    {
        path: '/Flow',
        name: 'Flow',
        component: () =>
            import ('../views/Flow.vue')
    },
    {
        path: '/Businesscoop',
        name: 'Businesscoop',
        component: () =>
            import ('../views/Businesscoop.vue')
    },
    {
        path: '/Schooldetail',
        name: 'Schooldetail',
        component: () =>
            import ('../views/Schooldetail.vue')
    },


]

const router = new VueRouter({
    routes
})

export default router